import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const THEME_KEY = 'edge_theme_mode';

try {
  const isDark = localStorage.getItem(THEME_KEY) === 'dark';
  document.documentElement.classList.toggle('dark', isDark);
  document.body.classList.toggle('dark', isDark);
} catch {
  // Ignore storage access issues (private mode/restricted environments).
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
